import styled from 'styled-components';
import PageTop from '../components/pageTop/PageTop';
import { use, useEffect, useRef, useState } from 'react';
import Menu from '../components/menu/Menu';
import BondFilter from './BondFilter';
import BondSerivce from '../../service/Bond';
import List from '../components/list/List';
import BondList from './BondList';
import { get } from 'http';
import Footer from '../components/footer/Footer';
import ScrollToTopButton from '../components/ScrollToTopButton';
type SortOption = { value: string; label: string };
const BondSearch = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const [filters, setFilters] = useState({
    category: [],
    region: [],
    itemType: [],
  });
  const [offset, setOffset] = useState<number>(0);
  const [sort, setSort] = useState<SortOption>({
    value: 'DA',
    label: '매각기일 빠른순',
  });
  const [limit, setLimit] = useState<number>(20);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState<number>(0);
  const [activeItem, setActiveItem] = useState<number | null>(null);
  const [selectedIdx, setSelectedIdx] = useState<number | null>(null);
  const [showLikeModal, setShowLikeModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({
    iidx: 0,
    group: '',
    group_idx: 0,
    level: 0,
    memo: '',
  });
  const [mode, setMode] = useState<string>('add');

  const getList = async (
    offset: number,
    sort: {
      value: string;
      label: string;
    },
    filters: any,
  ) => {
    try {
      setLoading(true);
      const res = await BondSerivce.list(
        filters.category.join(','),
        filters.region.join(','),
        filters.itemType.join(','),
        '',
        sort.value,
        limit,
        offset,
      );
      setData(res.data.list);
      setTotal(res.data.totalCount[0].total_count);
      setLoading(false);
    } catch (error) {
      console.log('getList 함수에서 에러 발생:', error);
      setLoading(false);
    }
  };

  const isFirstLoad = useRef(true); // 첫 로딩 여부를 저장

  useEffect(() => {
    console.log('2-1');
    if (offset === 0) return;
    console.log('2-2');
    getList(offset, sort, filters);
  }, [offset]);

  useEffect(() => {
    if (isFirstLoad.current) return; // 첫 로딩 시 실행 방지
    setOffset(0);
    getList(0, sort, filters);
  }, [filters]);

  useEffect(() => {
    if (isFirstLoad.current) {
      getList(0, sort, filters);
      isFirstLoad.current = false; // 첫 로딩 후 false로 변경
    }
  }, []);

  const prevSort = useRef(sort);

  useEffect(() => {
    if (prevSort.current === sort) return; // sort 값이 변경되지 않았으면 실행 안 함
    setOffset(0);
    getList(0, sort, filters);

    prevSort.current = sort; // 이전 sort 값 업데이트
  }, [sort]);

  return (
    <Container>
      <ScrollToTopButton />
      <PageTop text={'채권거래소'} setOpenMenu={setOpenMenu} />
      <div>
        <BondFilter filters={filters} setFilters={setFilters} />
        <BondList
          data={data}
          totalCount={total}
          sort={sort}
          setSort={setSort}
          offset={offset}
          setOffset={setOffset}
          bondFilters={filters}
          limit={limit}
          loading={loading}
          page="search"
          setSelectedIdx={setSelectedIdx}
          setShowLikeModal={setShowLikeModal}
          setMode={setMode}
          setSelectedItem={setSelectedItem}
          activeItem={activeItem}
          setActiveItem={setActiveItem}
          getList={getList}
        />
      </div>
      <Footer />
      {openMenu && <Menu page="main" setOpenMenu={setOpenMenu} />}
    </Container>
  );
};

export default BondSearch;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
`;
